import styles from './ApplicationDataCardHeader.module.css';
import { ApplicationDataCardHeaderActions } from './ApplicationDataCardHeaderActions';
import { ApplicationDataCardHeaderInfo } from './ApplicationDataCardHeaderInfo';

interface ApplicationDataCardHeaderProps {
  applicationID: string;
}

export const ApplicationDataCardHeader: React.FC<
  ApplicationDataCardHeaderProps
> = ({ applicationID }) => {
  return (
    <div className={styles.rootContainer}>
      <div className={styles.infoContainer}>
        <ApplicationDataCardHeaderInfo applicationID={applicationID} />
      </div>
      <div className={styles.actionsContainer}>
        <ApplicationDataCardHeaderActions applicationID={applicationID} />
      </div>
    </div>
  );
};
